import { clearSession, session, setPlayer } from "./session";
import type { Player, StreamMessage } from "./protocol";
import { navigateFromServer } from "./navigation-events";
import { request } from "./http";
import { apiUrl } from "./endpoints";
let source: EventSource | null = null;
let failures = 0;
const listeners = new Set<(message: StreamMessage) => void>();
export function subscribeBalanceStream(
  listener: (message: StreamMessage) => void,
) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
export function startBalanceStream() {
  if (source) return;
  if (!session.token) return;
  failures = 0;
  const token = session.token;
  source = new EventSource(
    apiUrl(`/player/game/amt_game?Authorization=${encodeURIComponent(`Bearer ${token}`)}`),
  );
  const connection = source;
  source.onmessage = async (event) => {
    if (source !== connection || session.token !== token) return;
    try {
      const message: StreamMessage<any> = JSON.parse(event.data);
      if (message.type === "LogBackIn") {
        stopBalanceStream();
        clearSession(token);
        return;
      }
      if (message.type === "HomeBackIn") navigateFromServer("/home");
      if (message.type === "Stop") stopBalanceStream();
      if (message.type === "playerGameInfo") setPlayer(message.data as Player);
      if (message.type === "PCoinData" && session.player) {
        session.player.Coin = message.data.coin;
        session.player.coin = message.data.coin;
      }
      if (message.type === "connect") {
        failures = 0;
        const player = await request<Player>("/player/get_player");
        if (source !== connection || session.token !== token) return;
        setPlayer(player);
      }
      listeners.forEach((listener) => listener(message));
    } catch {
      /* Ignore malformed heartbeat payloads; EventSource owns reconnects. */
    }
  };
  source.onerror = () => {
    if (source === connection && ++failures > 5) navigateFromServer("/");
  };
}
export function stopBalanceStream() {
  source?.close();
  source = null;
}
